import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _aggregationData = { results: '_aggregationResults' };
var _aggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
    groupedByValue: '_groupByValueResults',
};
var _assignBusinessScheduleRequest = {};
var _assignBusinessScheduleResponse = { staffMember: '_staffMember' };
var _assignCustomScheduleRequest = {};
var _assignCustomScheduleResponse = { staffMember: '_staffMember' };
var _connectStaffMemberToUserRequest = {};
var _connectStaffMemberToUserResponse = { staffMember: '_staffMember' };
var _countStaffMembersRequest = {};
var _countStaffMembersResponse = {};
var _createStaffMemberRequest = { staffMember: '_staffMember' };
var _createStaffMemberResponse = { staffMember: '_staffMember' };
var _deleteStaffMemberRequest = {};
var _deleteStaffMemberResponse = {};
var _disconnectStaffMemberFromUserRequest = {};
var _disconnectStaffMemberFromUserResponse = { staffMember: '_staffMember' };
var _getDeletedStaffMemberRequest = {};
var _getDeletedStaffMemberResponse = { staffMember: '_staffMember' };
var _getStaffMemberRequest = {};
var _getStaffMemberResponse = { staffMember: '_staffMember' };
var _groupByValueResults = { results: '_nestedValueAggregationResult' };
var _image = { urlExpirationDate: 'google.protobuf.Timestamp' };
var _listDeletedStaffMembersRequest = {};
var _listDeletedStaffMembersResponse = { staffMembers: '_staffMember' };
var _mediaItem = { image: '_image' };
var _nestedAggregationResults = {
    ranges: '_rangeResults',
    scalar: '_scalarResult',
};
var _nestedValueAggregationResult = {
    nestedResults: '_nestedAggregationResults',
};
var _queryStaffMembersMultiLanguageRequest = {};
var _queryStaffMembersMultiLanguageResponse = {
    staffMembers: '_staffMember',
    translatedStaffMembers: '_staffMember',
};
var _queryStaffMembersRequest = {};
var _queryStaffMembersResponse = { staffMembers: '_staffMember' };
var _rangeAggregationResult = {
    from: 'google.protobuf.DoubleValue',
    to: 'google.protobuf.DoubleValue',
};
var _rangeResults = { results: '_rangeAggregationResult' };
var _removeStaffMemberFromTrashBinRequest = {};
var _removeStaffMemberFromTrashBinResponse = {};
var _restoreStaffMemberFromTrashBinRequest = {};
var _restoreStaffMemberFromTrashBinResponse = { staffMember: '_staffMember' };
var _scalarResult = { value: 'DOUBLE' };
var _searchStaffMembersRequest = {};
var _searchStaffMembersResponse = {
    staffMembers: '_staffMember',
    aggregationData: '_aggregationData',
};
var _staffMember = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    mainMedia: '_mediaItem',
};
var _updateStaffMemberRequest = {
    fieldMask: 'google.protobuf.FieldMask',
    staffMember: '_staffMember',
};
var _updateStaffMemberResponse = { staffMember: '_staffMember' };
function resolveWixBookingsStaffV1StaffMembersServiceUrl(opts) {
    var domainToMappings = {
        'www._base_domain_': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/staff-members',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/bookings/v1/staff-members',
                destPath: '/v1/staff-members',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a StaffMember. */
export function createStaffMember(payload) {
    var _a = serializer(_createStaffMemberRequest, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createStaffMemberResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __createStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.CreateStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createStaffMember.fromReq = fromReq;
    __createStaffMember.__isAmbassador = true;
    return __createStaffMember;
}
/** Retrieves a StaffMember by id. */
export function getStaffMember(payload) {
    var _a = serializer(_getStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getStaffMemberResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __getStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'GET',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.GetStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getStaffMember.fromReq = fromReq;
    __getStaffMember.__isAmbassador = true;
    return __getStaffMember;
}
/** Get a deleted staff member from the trash-bin by id */
export function getDeletedStaffMember(payload) {
    var _a = serializer(_getDeletedStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getDeletedStaffMemberResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __getDeletedStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'GET',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.GetDeletedStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v2/staff-members/trash-bin/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getDeletedStaffMember.fromReq = fromReq;
    __getDeletedStaffMember.__isAmbassador = true;
    return __getDeletedStaffMember;
}
/**
 * List deleted staff members from the trash-bin.
 * List runs with these defaults, which you can override:
 * - `paging.limit` is `50`.
 */
export function listDeletedStaffMembers(payload) {
    var _a = serializer(_listDeletedStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listDeletedStaffMembersResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __listDeletedStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'GET',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.ListDeletedStaffMembers',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v2/staff-members/trash-bin',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listDeletedStaffMembers.fromReq = fromReq;
    __listDeletedStaffMembers.__isAmbassador = true;
    return __listDeletedStaffMembers;
}
/**
 * Remove a staff member from the trash bin, permanently deleting it.
 * This action is irreversible.
 */
export function removeStaffMemberFromTrashBin(payload) {
    var _a = serializer(_removeStaffMemberFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeStaffMemberFromTrashBinResponse, {}).fromJSON;
    function __removeStaffMemberFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'DELETE',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.RemoveStaffMemberFromTrashBin',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v2/staff-members/trash-bin/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __removeStaffMemberFromTrashBin.fromReq = fromReq;
    __removeStaffMemberFromTrashBin.__isAmbassador = true;
    return __removeStaffMemberFromTrashBin;
}
/** Restore a staff member from the trash bin. */
export function restoreStaffMemberFromTrashBin(payload) {
    var _a = serializer(_restoreStaffMemberFromTrashBinRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_restoreStaffMemberFromTrashBinResponse, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }).fromJSON;
    function __restoreStaffMemberFromTrashBin(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.RestoreStaffMemberFromTrashBin',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v2/staff-members/trash-bin/{staffMemberId}/restore',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __restoreStaffMemberFromTrashBin.fromReq = fromReq;
    __restoreStaffMemberFromTrashBin.__isAmbassador = true;
    return __restoreStaffMemberFromTrashBin;
}
/**
 * Update a StaffMember, supports partial update
 * Pass the latest `revision` for a successful update
 */
export function updateStaffMember(payload) {
    var _a = serializer(_updateStaffMemberRequest, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateStaffMemberResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __updateStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'PATCH',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.UpdateStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMember.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateStaffMember.fromReq = fromReq;
    __updateStaffMember.__isAmbassador = true;
    return __updateStaffMember;
}
/** Deletes a StaffMember. */
export function deleteStaffMember(payload) {
    var _a = serializer(_deleteStaffMemberRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteStaffMemberResponse, {}).fromJSON;
    function __deleteStaffMember(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'DELETE',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.DeleteStaffMember',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteStaffMember.fromReq = fromReq;
    __deleteStaffMember.__isAmbassador = true;
    return __deleteStaffMember;
}
/** Query StaffMembers using [WQL - Wix Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) */
export function queryStaffMembers(payload) {
    var _a = serializer(_queryStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStaffMembersResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __queryStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.QueryStaffMembers',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStaffMembers.fromReq = fromReq;
    __queryStaffMembers.__isAmbassador = true;
    return __queryStaffMembers;
}
export function queryStaffMembersMultiLanguage(payload) {
    var _a = serializer(_queryStaffMembersMultiLanguageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryStaffMembersMultiLanguageResponse, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }).fromJSON;
    function __queryStaffMembersMultiLanguage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.QueryStaffMembersMultiLanguage',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/query-multi-language',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryStaffMembersMultiLanguage.fromReq = fromReq;
    __queryStaffMembersMultiLanguage.__isAmbassador = true;
    return __queryStaffMembersMultiLanguage;
}
/** Counts staff members according to given criteria. */
export function countStaffMembers(payload) {
    var _a = serializer(_countStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countStaffMembersResponse, {}).fromJSON;
    function __countStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.CountStaffMembers',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countStaffMembers.fromReq = fromReq;
    __countStaffMembers.__isAmbassador = true;
    return __countStaffMembers;
}
/** Connects staff member to a Wix user */
export function connectStaffMemberToUser(payload) {
    var _a = serializer(_connectStaffMemberToUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_connectStaffMemberToUserResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __connectStaffMemberToUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.ConnectStaffMemberToUser',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}/connect-staff-member-to-user',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __connectStaffMemberToUser.fromReq = fromReq;
    __connectStaffMemberToUser.__isAmbassador = true;
    return __connectStaffMemberToUser;
}
/** Search StaffMembers using Nile Search[WQL - Wix Query Language](https://github.com/wix-private/search/tree/master/nile) */
export function searchStaffMembers(payload) {
    var _a = serializer(_searchStaffMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_searchStaffMembersResponse, {
        _aggregationData: _aggregationData,
        _aggregationResults: _aggregationResults,
        _groupByValueResults: _groupByValueResults,
        _image: _image,
        _mediaItem: _mediaItem,
        _nestedAggregationResults: _nestedAggregationResults,
        _nestedValueAggregationResult: _nestedValueAggregationResult,
        _rangeAggregationResult: _rangeAggregationResult,
        _rangeResults: _rangeResults,
        _scalarResult: _scalarResult,
        _staffMember: _staffMember,
    }).fromJSON;
    function __searchStaffMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.SearchStaffMembers',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/search',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __searchStaffMembers.fromReq = fromReq;
    __searchStaffMembers.__isAmbassador = true;
    return __searchStaffMembers;
}
/** Disconnects a staff member from the Wix user. */
export function disconnectStaffMemberFromUser(payload) {
    var _a = serializer(_disconnectStaffMemberFromUserRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disconnectStaffMemberFromUserResponse, { _image: _image, _mediaItem: _mediaItem, _staffMember: _staffMember }).fromJSON;
    function __disconnectStaffMemberFromUser(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.DisconnectStaffMemberFromUser',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}/disconnect-staff-member-from-user',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disconnectStaffMemberFromUser.fromReq = fromReq;
    __disconnectStaffMemberFromUser.__isAmbassador = true;
    return __disconnectStaffMemberFromUser;
}
/** Assigns the provided schedule to the StaffMember */
export function assignCustomSchedule(payload) {
    var _a = serializer(_assignCustomScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignCustomScheduleResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __assignCustomSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.AssignCustomSchedule',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}/assign-custom-schedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignCustomSchedule.fromReq = fromReq;
    __assignCustomSchedule.__isAmbassador = true;
    return __assignCustomSchedule;
}
/** Assigns the business schedule to the StaffMember */
export function assignBusinessSchedule(payload) {
    var _a = serializer(_assignBusinessScheduleRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignBusinessScheduleResponse, {
        _image: _image,
        _mediaItem: _mediaItem,
        _staffMember: _staffMember,
    }).fromJSON;
    function __assignBusinessSchedule(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.bookings.staff.v1.staff_member',
            method: 'POST',
            methodFqn: 'wix.bookings.staff.v1.StaffMembersService.AssignBusinessSchedule',
            url: resolveWixBookingsStaffV1StaffMembersServiceUrl({
                protoPath: '/v1/staff-members/{staffMemberId}/assign-business-schedule',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assignBusinessSchedule.fromReq = fromReq;
    __assignBusinessSchedule.__isAmbassador = true;
    return __assignBusinessSchedule;
}
//# sourceMappingURL=http.impl.js.map